import { Link, useLocation } from "react-router-dom";
import { ShoppingBasket } from "lucide-react";
import { formatRupiah } from "../lib/format";
import { useApp } from "../context/AppContext";

/**
 * Fixed bottom cart pill (mobile only). Mimics GoFood/GrabFood pattern.
 * Hidden on desktop and on checkout/payment routes (to avoid overlapping CTAs).
 */
const MobileCartBar = () => {
  const { cartCount, cartTotal, cartSubtotal, openCart } = useApp();
  const location = useLocation();

  if (cartCount === 0) return null;

  // Hide on routes where a persistent CTA is already present
  const hiddenRoutes = ["/payment", "/sukses", "/checkout", "/admin"];
  if (hiddenRoutes.some((p) => location.pathname.startsWith(p))) return null;

  const displayTotal = cartTotal > 0 ? cartTotal : cartSubtotal;

  return (
    <div
      className="md:hidden fixed left-0 right-0 bottom-4 z-40 px-4 pointer-events-none"
      data-testid="mobile-cart-bar"
    >
      <button
        type="button"
        onClick={openCart}
        className="pointer-events-auto w-full flex items-center justify-between gap-3 bg-emerald-600 hover:bg-emerald-700 text-white rounded-full pl-5 pr-4 py-3 shadow-xl shadow-emerald-900/20 transition active:scale-[0.99]"
        data-testid="mobile-cart-bar-button"
      >
        <div className="text-left leading-tight">
          <p className="text-sm font-semibold">
            <span data-testid="mobile-cart-count">{cartCount}</span> item
          </p>
          <p className="text-xs text-emerald-50/90">Teras Alami</p>
        </div>
        <div className="flex items-center gap-3">
          <span
            className="font-display text-lg font-semibold"
            data-testid="mobile-cart-total"
          >
            {formatRupiah(displayTotal)}
          </span>
          <span className="inline-flex w-10 h-10 rounded-full bg-white/15 items-center justify-center">
            <ShoppingBasket className="w-5 h-5" />
          </span>
        </div>
      </button>
    </div>
  );
};

export default MobileCartBar;
